import { create } from "zustand";
import { ConversationalModule } from "@gen/agency/v1/agency_pb";

interface ChatState {
  module: ConversationalModule | undefined;
  cookiesAccepted: boolean;
  setModule: (module: ConversationalModule | undefined) => void;
  setCookiesAccepted: (accepted: boolean) => void;
}

export const useChatStore = create<ChatState>((set) => ({
  module: undefined,
  cookiesAccepted: localStorage.getItem("cookie-accepted") === "true",
  setModule: (module) => set({ module }),
  setCookiesAccepted: (cookiesAccepted) => set({ cookiesAccepted }),
}));
